import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserCardResponse} from "../interface/userCardResponse";
import {ImageType} from "../enums/image-type-enum";
import {ActivatedRoute, Router} from "@angular/router";
import {UserCardUtil} from "../utilityClass/userCardUtil";
import {CardsHistoryService} from "../service/cards-history.service";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {QrGenerateComponent} from "../qr-generate/qr-generate.component";
import {UserCardService} from "../service/user-card.service";
import {TeamNotificationService} from "../service/team-notification-service";
import {UserCardUsernameEditComponent} from "../admin-page/user-card-username-edit/user-card-username-edit.component";
import {SubscriptionResponse} from "../interface/subscriptionResponse";
import {Team} from "../interface/team";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {
  DEFAULT_COMMISSION,
  IS_BUSINESS_FAILED_MESSAGE,
  IS_BUSINESS_SUCCESSFULLY_MESSAGE,
  TEAM_SUBSCRIPTION_EXPIRY_ERROR_ALERT,
  USER_CARD_DUPLICATION_MESSAGE
} from "../constants/global.constants";
import {HttpErrorResponse} from "@angular/common/http";
import {SubscriptionService} from "../service/subscription.service";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {
  UserCardCommissionEditComponent
} from "../admin-page/user-card-commission-edit/user-card-commission-edit.component";
import {UserCardCommissionDialogData} from "../interface/UserCardCommissionDialogData";
import {ConnectReservedQrComponent} from "../connect-reserved-qr/connect-reserved-qr.component";
import {DialogService} from "../service/dialog.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-single-card-list',
  templateUrl: './single-card-list.component.html',
  styleUrls: ['./single-card-list.component.scss', "single-card-list-media.component.scss"]
})
export class SingleCardListComponent implements OnInit {

  @Input() singleCard: UserCardResponse | any;
  @Input() isFavoriteMap: { [key: string]: boolean } = {};
  @Input() isStarActive: boolean = false;
  @Input() showEditSection: boolean = false;
  @Input() isDeleteButtonFromHistoryActive: boolean = false;
  @Input() isDeleteButtonFromTeamActive: boolean = false;
  @Input() isViewedCard: boolean = true;
  @Input() isCardActive?: boolean = true;
  @Input() currentUserEmail?: string;
  @Input() currentUserId?: string;
  @Input() isAdminCard?: boolean = false;
  @Input() isEditing: boolean = false;
  @Input() isCardActivePreview: boolean = false;
  @Input() isCardSpecializationPreview: boolean = false;
  @Input() isIndividualCards: boolean = false;
  @Input() activeSubscription!: SubscriptionResponse
  @Input() isTeam: boolean = false;
  @Input() isAdmin: boolean = false;
  @Input() team!: Team
  @Input() parentUserId?: bigint;
  @Input() isBusiness?: boolean = false;
  @Input() reservedIdentificationId: string | null = null;

  @Output() deleteCard: EventEmitter<void> = new EventEmitter();
  @Output() toggleCardFromIndividuals: EventEmitter<bigint> = new EventEmitter();
  @Output() toggleCardFromTeam = new EventEmitter<bigint>();
  @Output() deleteCardFromIndividuals: EventEmitter<bigint> = new EventEmitter();
  @Output() editCardUsername: EventEmitter<{ id: bigint, cardId: string }> = new EventEmitter();
  @Output() cardAdded = new EventEmitter<UserCardResponse>();
  @Output() activeReservedQrCard: EventEmitter<string> = new EventEmitter();

  clicked: boolean = false;
  companyLogoExists: boolean = true;

  currentRoute: string | null = null;

  protected readonly ImageType = ImageType;

  constructor(
    private router: Router,
    private userCardUtil: UserCardUtil,
    private scannedHistoryService: CardsHistoryService,
    private userCardService: UserCardService,
    private dialog: MatDialog,
    private teamNotificationService: TeamNotificationService,
    private activatedRoute: ActivatedRoute,
    private subscriptionService: SubscriptionService,
    private snackBarUtil: SnackBarUtil,
    private changeDetector: ChangeDetectorRef,
    private dialogService: DialogService,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.currentRoute = this.activatedRoute.snapshot.url.join('/');
    this.currentRoute = this.activatedRoute.snapshot.url.join('/');
    const imageUrl = this.getUserCardImage(this.singleCard.userCardResponse.id, ImageType.COMPANY_LOGO);
    this.userCardService.checkImageExists(imageUrl).subscribe(exists => {
      this.companyLogoExists = exists;
    });
  }

  toggle(cardId: string, reservedId: string, event: Event): void {
    event.stopPropagation();
    this.activeReservedQrCard.emit(cardId)
    this.openPopup(cardId, reservedId)
  }

  openPopup(cardId: string, reservedId: string): void {
    this.dialogService.openReservedQrPopup(
      ConnectReservedQrComponent,
      { cardId, reservedIdentificationId: reservedId },
      this.currentRoute!,
      () => {
        this.singleCard.userCardResponse.isReservedCardActive = false;
      }
    );
  }

  isCardInactive() {
    return (!this.isCardActive || this.singleCard.userCardResponse.subscriptionExpired);
  }

  onDeleteFromHistory(id: bigint, event: any) {
    event.stopPropagation();
    this.scannedHistoryService.deleteById(id).subscribe(() => {
      this.deleteCard.emit(event);
    });
  }

  onStar(cardId: bigint, event: any) {
    if(this.isCardInactive() || !this.isStarActive) {
      return;
    }
    event.stopPropagation();
    this.userCardUtil.toggleFavorite(cardId, event, this.isFavoriteMap)
  }

  showQRCode(userCardId: bigint, event: any): void {
    event.stopPropagation();

    this.userCardService.generateQRCode(userCardId).subscribe((qrCodeBlob: Blob) => {
      const qrUrl = URL.createObjectURL(qrCodeBlob);
      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = {
        userCard: this.singleCard.userCardResponse,
        qrCodeUrl: qrUrl
      };

      dialogConfig.panelClass = 'qr-dialog';

      this.dialog.open(QrGenerateComponent, dialogConfig);
    });
  }

  truncateText(value: string, limit: number): string {
    if (value.length <= limit) {
      return value;
    }
    return value.substring(0, limit) + '...';
  }

  navigateToUserSinglePage(userCardId: string) {
    if (this.isAdmin) {
      window.open(`/${userCardId}`, '_blank');
    } else {
      this.router.navigate(['/', userCardId]);
    }
  }

  getUserCardImage(id: bigint, type: ImageType) {
    return this.userCardService.getCardImage(id, type);
  }

  toggleSwitch(event: any) {
    event.stopPropagation();
    this.isCardActive = !this.isCardActive;
    this.teamNotificationService.notifyChangeActivity(this.singleCard.userCardResponse.id);
  }

  toggleSwitchActiveOrInActiveCard(id: bigint, event: Event): void {
    event.stopPropagation();
    this.isCardActive = !this.isCardActive;
    if (this.isIndividualCards) {
      this.toggleCardFromIndividuals.emit(id);
    } else {
      this.toggleCardFromTeam.emit(id);
    }
  }

  openDeleteModal() {
    if (!this.isIndividualCards) {
      this.teamNotificationService.notifyDelete(this.singleCard.userCardResponse.cardId);
    } else {
      this.deleteCardFromIndividuals.emit(this.singleCard.userCardResponse.id);
    }
  }

  editCard() {
    this.router.navigate(['/cards/edit', this.singleCard.userCardResponse.id],
      {
        queryParams: {
          currentRoute: this.currentRoute,
        },
        state: {activeSubscription: this.activeSubscription}
      })
      .then();
  }

  editUserCardUsernameDialog(event: any, id: bigint, cardId: string) {
    event.stopPropagation()
    const dialogRef = this.dialog.open(UserCardUsernameEditComponent, {
      data: {
        cardId: cardId,
        id: id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.singleCard.userCardResponse.cardId = result.cardId;
        this.singleCard.userCardResponse.qrUsername = result.cardId;
        this.editCardUsername.emit(result);
      }
    });
  }

  editUserCardCommissionDialog(event: Event, id: bigint, commission: number): void {
    event.stopPropagation();

    const dialogData: UserCardCommissionDialogData = {
      commission: commission || DEFAULT_COMMISSION,
      id: id
    };

    const dialogRef = this.dialog.open(UserCardCommissionEditComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe({
      next: (result: UserCardCommissionDialogData) => {
        if (result) {
          this.singleCard.userCardResponse.commission = result.commission;
          this.changeDetector.detectChanges();
        }
      }
    })
  }

  openEditDialogForMemberAdd(): void {
    const teamOwnerId = this.team?.owner?.id;
    this.subscriptionService.checkTeamSubscription(teamOwnerId).subscribe({
      next: (isTeamSubscription) => {
        if (isTeamSubscription) {
          this.userCardService.duplicate(this.singleCard.userCardResponse.id).subscribe(res=>{
            this.cardAdded.emit(res);
            const msg = this.translateService.instant('user_card_duplicated_success');
            this.showSnackbar(MockupDataModel.success(msg), SnackBarUtil.CLASSES.success)
          })
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 409) {
          this.router.navigate(['/subscriptions'], {state: {isShowAllSubscriptions: true, isIndividualActive: false}});
          this.showSnackbar(MockupDataModel.error(this.translateService.instant('invite_limit_error')), SnackBarUtil.CLASSES.error)
        } else if (error.status === 404) {
          this.router.navigate(['/subscriptions'], {state: {isShowAllSubscriptions: true, isIndividualActive: false}});
          this.showSnackbar(MockupDataModel.error(TEAM_SUBSCRIPTION_EXPIRY_ERROR_ALERT), SnackBarUtil.CLASSES.error)
        }
      }
    });
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBarUtil.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }

  toggleBusinessStatus(event: any) {
    event.stopPropagation();
    if (!this.parentUserId) return;

    const newBusinessStatus = !this.isBusiness;
    const userId = this.parentUserId;
    const cardId = this.singleCard.userCardResponse.cardId;

    this.userCardService.updateIsBusiness(userId, cardId, newBusinessStatus).subscribe({
      next: () => {
        this.singleCard.userCardResponse.isBusiness = newBusinessStatus;
        this.showSnackbar(MockupDataModel.success(IS_BUSINESS_SUCCESSFULLY_MESSAGE), SnackBarUtil.CLASSES.success)

      },
      error: () => {
        this.showSnackbar(MockupDataModel.error(IS_BUSINESS_FAILED_MESSAGE), SnackBarUtil.CLASSES.error)
      }
    });
  }

  navigateToPayment() {
    this.router.navigate([`/${this.singleCard.userCardResponse.cardId}/payment`]).catch();
  }

  protected readonly DEFAULT_COMMISSION = DEFAULT_COMMISSION;
}
